
    import Component from "vue-class-component";
    import {
        EducationalQualificationModel,
        EducationalQualificationOptions,
        factory,
        QualificationActions,
        QualificationsClient
    } from "@/api-client";
    import {QualificationAddBase} from "@/features/documents/qualifications/views/QualificationAddBase";
    import FormLayout from "@/features/personProfile/components/FormLayout.vue";
    import FileUploader from "@/components/FileUploader.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import {NavigationGuardNext} from "vue-router/types/router";
    import CheckboxInput from "@/features/shared/components/CheckboxInput.vue";
    import {Prop} from "vue-property-decorator";
    import EducationalQualificationUpsertForm from "@/features/documents/qualifications/components/EducationalQualificationUpsertForm.vue";

    interface Props {
        seafarerId: string;
        qualificationPreloadedActions: QualificationActions;
        options: EducationalQualificationOptions;
    }

    @Component({
        components: {
            FileUploader,
            FormLayout,
            LabelOptional,
            CheckboxInput,
            EducationalQualificationUpsertForm
        },
        async beforeRouteEnter(to, from, next : NavigationGuardNext<EducationalQualificationAdd>) {
            const props = to.meta!.props as Props;
            props.seafarerId = to.params.seafarerId;
            Promise.all([
                new QualificationsClient().availableActions(props.seafarerId, null),
                new QualificationsClient().educationalOptions()
            ]).then(values => {
                props.qualificationPreloadedActions = values[0];
                props.options = values[1];
                next();
            }).catch(e => next(e))
        }
    })
    export default class EducationalQualificationAdd extends QualificationAddBase<EducationalQualificationModel> {
        @Prop({ required: true })
        qualificationPreloadedActions!: QualificationActions;
        @Prop({ required: true })
        options!: EducationalQualificationOptions;

        initialModel: EducationalQualificationModel = factory.create(EducationalQualificationModel);

        async submitQualification(model: EducationalQualificationModel) {
            return await this.submit(model);
        }
    }
